import { render, staticRenderFns } from "./funcoesUsuarioMenu.vue?vue&type=template&id=0d1322a4&scoped=true&"
import script from "./funcoesUsuarioMenu.vue?vue&type=script&lang=js&"
export * from "./funcoesUsuarioMenu.vue?vue&type=script&lang=js&"
import style0 from "./funcoesUsuarioMenu.vue?vue&type=style&index=0&id=0d1322a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1322a4",
  null
  
)

export default component.exports